import { parseItemStat, StoredItem } from "LibMargoWorld/item";

export function addItemRarityClass(el: Element, it: StoredItem, stats: Record<string, string>) {
    let rarity = stats.rarity;

    el.classList.add(`rarity-${rarity}`);
}

function truncateNumber(n: number, decimals: number) {
    const s = String(n);
    const dot = s.indexOf(".");
    if (dot > -1) {
        if (decimals == 0) {
            return s.substring(0, dot);
        }
        let truncated = s.substring(0, dot + decimals + 1);
        while (truncated.charAt(truncated.length - 1) == "0") {
            truncated = truncated.substring(0, truncated.length - 2);
        }
        return truncated;
    } else {
        return s;
    }
}

function getShortAmtText(amt: number) {
    if (amt < 1000) {
        return String(amt);
    } else if (amt < 1e4) {
        return `${truncateNumber(amt / 1000, 2)}k`;
    } else if (amt < 1e5) {
        return `${truncateNumber(amt / 1000, 1)}k`;
    } else if (amt < 1e6) {
        return `${truncateNumber(amt / 1000, 0)}k`;
    } else {
        // Engine max stack caps at 4m, so no need to go further
        return `${truncateNumber(amt / 1e6, 2)}m`;
    }
}

function addItemQuantity(el: Element, it: StoredItem, stats: Record<string, string>) {
    const amt = stats.amount ?? stats.ammo;
    if (typeof amt != "undefined") {
        const n = Number(amt);
        if (!isNaN(n) && n > 1) {
            const label = document.createElement("span");
            label.classList.add("item-quantity-label");
            label.innerText = getShortAmtText(n);
            el.querySelector(".item-inner")?.appendChild(label);
        }
    }
}

export function createItemDisplay(item: StoredItem, existingDisplay?: HTMLDivElement) {
    const disp = existingDisplay ?? document.createElement("div");
    disp.classList.add("item-display");
    const tipContent = window.MargoTipsParser.getTip(item);
    const rarity = parseItemStat(item.stat).rarity ?? "common";
    disp.innerHTML = `<div class="tip-wrapper normal-tip static custom" data-type="t_item" data-item-type="${rarity}"><div class="content">${tipContent}</div></div>`;
    const itemIcon = document.createElement("div");
    itemIcon.classList.add("item");
    itemIcon.innerHTML = `<img src="https://micc.garmory-cdn.cloud/obrazki/itemy/${item.icon}">`;
    itemIcon.dataset.tip = `PPM - dodaj do zestawu ekwipunku`;
    disp.querySelector(".item-head")!.prepend(itemIcon);
    return disp;
}

export function loadItemsFromElement(el: HTMLElement) {
    for (const disp of Array.from(el.querySelectorAll(".item-display"))) {
        if (!(disp instanceof HTMLElement)) {
            continue;
        }

        const data = disp.dataset.item!;
        try {
            const item = <StoredItem>JSON.parse(data);
            // @ts-ignore
            createItemDisplay(item, disp);
        } catch (e) {
            console.error(e);
        }
    }

    for (const item of Array.from(el.querySelectorAll(".margonem_item"))) {
        const json = item.getAttribute("data-itemtip")!;
        const it = <StoredItem>JSON.parse(json);
        const stats = parseItemStat(it.stat);
        addItemRarityClass(item, it, stats);
        addItemQuantity(item, it, stats);
    }
}

export function initItemLoader() {
    loadItemsFromElement(document.body);
}
